var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-list" },
    [
      _c(
        "div",
        { staticClass: "toolbar-container" },
        [
          _c("TicketFilterToolbar", {
            ref: "filterToolbar",
            attrs: {
              "status-list": _vm.statusList,
              "default-filter-template": _vm.defaultFilterTemplate,
            },
            model: {
              value: _vm.filters,
              callback: function ($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex gap-5" },
            [
              _c(
                "SupsisButton",
                {
                  attrs: { primary: "", small: "" },
                  on: { click: _vm.refreshData },
                },
                [
                  _c("small", { staticClass: "keyboard-shortcut" }, [
                    _vm._v(_vm._s(_vm.$t("ticket.shortcutRefresh"))),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.refresh")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                { attrs: { small: "" }, on: { click: _vm.openColumnSettings } },
                [_c("i", { staticClass: "fas fa-cog" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "view-switcher" }, [
                _c(
                  "div",
                  { staticClass: "supsis-button-group" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: _vm.mode === "list", small: "" },
                        on: {
                          click: function ($event) {
                            return _vm.setMode("list")
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-list" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: _vm.mode === "kanban", small: "" },
                        on: {
                          click: function ($event) {
                            return _vm.setMode("kanban")
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-columns" })]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.checkboxOption.selectedRowKeys.length > 0
        ? _c("div", { staticClass: "bulk-action-bar" }, [
            _c("div", { staticClass: "selected-count" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.checkboxOption.selectedRowKeys.length) +
                  " " +
                  _vm._s(_vm.$t("ticket.ticketSelection")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bulk-actions" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticClass: "bulk-action-button select-all",
                    attrs: { type: "default" },
                    on: { click: _vm.selectAll },
                  },
                  [
                    _c("small", { staticClass: "keyboard-shortcut" }, [
                      _vm._v(_vm._s(_vm.$t("ticket.shortcutSelectAll"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("chatbotv2.selectAll")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "bulk-action-button deselect-all",
                    attrs: { type: "default" },
                    on: { click: _vm.deselectAll },
                  },
                  [
                    _c("small", { staticClass: "keyboard-shortcut" }, [
                      _vm._v(_vm._s(_vm.$t("ticket.shortcutDeselect"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.cancel")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "bulk-action-button assign-agent",
                    attrs: { type: "primary" },
                    on: { click: _vm.showBulkAssignModal },
                  },
                  [
                    _c("small", { staticClass: "keyboard-shortcut" }, [
                      _vm._v(_vm._s(_vm.$t("ticket.shortcutAssign"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.assignRep")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "bulk-action-button close-tickets",
                    attrs: { type: "warning" },
                    on: { click: _vm.bulkCloseTickets },
                  },
                  [
                    _c("small", { staticClass: "keyboard-shortcut" }, [
                      _vm._v(_vm._s(_vm.$t("ticket.shortcutBulkClose"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("ticket.bulkClose")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "bulk-action-button delete-tickets",
                    attrs: { type: "danger" },
                    on: { click: _vm.deleteSelectedTickets },
                  },
                  [
                    _c("small", { staticClass: "keyboard-shortcut" }, [
                      _vm._v(_vm._s(_vm.$t("ticket.shortcutDelete"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.delete")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "list"
        ? _c(
            "div",
            [
              _c("supsis-table", {
                attrs: {
                  columns: _vm.columns,
                  rows: _vm.tickets,
                  "bottom-pagination": true,
                  "pagination-cursor": _vm.paginationCursor,
                  options: {
                    eventCustomOption: _vm.eventCustomOption,
                    checkboxOption: _vm.checkboxOption,
                  },
                  id: "ticket-list-table",
                  attributes: {
                    style: { width: _vm.getMaxWidth() + "px" },
                    "scroll-width": _vm.getMaxWidth() + 180,
                  },
                },
                on: { "cursor-changed": _vm.onCursorChanged },
              }),
              _vm._v(" "),
              _vm.isBulkAssignModalVisible
                ? _c(
                    "Modal2",
                    {
                      attrs: {
                        title: _vm.$t("auto.collectiveTicketBulkAssignTitle"),
                        showFooter: "",
                        className: "agent-picker-modal",
                      },
                      on: {
                        cancel: _vm.closeBulkAssignModal,
                        ok: _vm.handleBulkAssignConfirm,
                      },
                    },
                    [
                      _c("AgentPicker", {
                        attrs: { single: "" },
                        on: { confirm: _vm.handleBulkAssignConfirm },
                        model: {
                          value: _vm.selectedBulkAgent,
                          callback: function ($$v) {
                            _vm.selectedBulkAgent = $$v
                          },
                          expression: "selectedBulkAgent",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm.mode === "kanban"
        ? _c(
            "div",
            [
              _c("TicketKanbanBoard", {
                attrs: {
                  tickets: _vm.tickets,
                  statusList: _vm.statusList,
                  selectedTickets: _vm.checkboxOption.selectedRowKeys,
                },
                on: {
                  "load-more-tickets": _vm.loadMoreTickets,
                  "update-ticket-status": function (ref) {
                    var ticketId = ref.ticketId
                    var statusTitle = ref.statusTitle

                    return _vm.handleChangeStatus(ticketId, statusTitle)
                  },
                  "toggle-ticket-selection": _vm.toggleTicketSelection,
                  "toggle-select-all": _vm.toggleSelectAll,
                  "ticket-clicked": _vm.viewTicketFromKanban,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showingTicket
        ? _c("AwaitingTicketDetails", {
            attrs: {
              ticket: _vm.showingTicket,
              statusList: _vm.statusList,
              "change-ticket-status": _vm.handleChangeStatus,
            },
            on: {
              close: function ($event) {
                _vm.showingTicket = null
              },
              confirm: _vm.sendResponse,
              replyTrendyolQuestion: _vm.replyTrendyolQuestion,
              sendAsComment: _vm.sendAsComment,
              deleteComment: _vm.deleteComment,
              changeHideStatusIGComment: _vm.changeHideStatusIGComment,
              navigate: _vm.navigateTicket,
              "close-ticket": _vm.closeTicket,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAgentPickerVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("ticket.appointingRepresentative"),
                showFooter: "",
                className: "agent-picker-modal",
              },
              on: {
                cancel: _vm.closeAgentPicker,
                ok: _vm.handleAgentPickerConfirm,
              },
            },
            [
              _c("AgentPicker", {
                attrs: { single: "" },
                on: { confirm: _vm.handleAgentPickerConfirm },
                model: {
                  value: _vm.selectedTicket.agents,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedTicket, "agents", $$v)
                  },
                  expression: "selectedTicket.agents",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isVoiceAssistantModalVisible
        ? _c("TicketVoiceAssistantManual", {
            on: {
              close: function ($event) {
                _vm.isVoiceAssistantModalVisible = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isColumnSettingsModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("ticket.columnSettings"),
                showFooter: false,
                className: "column-settings-modal",
              },
              on: { cancel: _vm.closeColumnSettings },
            },
            [
              _c("ColumnSelector", {
                attrs: {
                  "ticket-fields": _vm.ticketFields,
                  "contact-property-fields": _vm.contactPropertyFields,
                },
                on: {
                  save: _vm.saveColumnSettings,
                  cancel: _vm.closeColumnSettings,
                },
                model: {
                  value: _vm.selectedColumns,
                  callback: function ($$v) {
                    _vm.selectedColumns = $$v
                  },
                  expression: "selectedColumns",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }